// components/filtv/filtvConstants.js

export const COMPANY_NAME = "Think5Whys";
export const CHANNEL_START = 100;

// Minimum time to keep showing "Tuning in..." before revealing the
// off-air message, even if the API responds faster. Purely a feel thing.
export const MIN_TUNING_IN_MS = 1200;

// NOTE: placeholders — point these at your real endpoints whenever the
// backend is ready. No '/api' prefix, per your convention. Until then,
// useFiltvData() silently falls back to filtvDemoData.js.
export const FILTV_CHANNELS_URL = "/filtv/channels";
export const FILTV_ADS_URL = "/filtv/advertisements";
export const FILTV_AD_BEST_URL = "/filtv/advertisements/best";
export const FILTV_AD_AVAILABILITY_URL = "/filtv/advertisements/availability";

// Fixed, non-negotiable route contracts.
export const ROUTES = {
    // digitalTwin: (advertisementCode) => `/twiworld/filtv/${advertisementCode}`,
    digitalTwin: () => "/twiworldlite",
    product: (cartProductCode) => `/herkart/product/${cartProductCode}`,
    orderHistory: "/herkart/orders/history",
};

export const OFF_AIR_MESSAGES = [
    "This channel is off air right now 📡",
    "No live merchant here yet — try another channel 📺",
    "Signal's a little quiet here. More deals coming soon 🔌",
];
